import React from 'react';

import moment from 'moment';

import { CommentaireResponseDto } from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';
import { DATE_FORMAT_WITH_TIME } from 'utils/formats';
import { userEventDataDtoProfileEnumToUserDtoProfileEnum } from 'utils/mappers/eventDataDtoProfileEnumToUserDtoProfileEnum';
import { getLibelleEntiteRattachement } from 'utils/UserUtils';

import { CommentaireForm } from '../../CommentaireForm/CommentaireForm';
import { ModalDeleteCommentaire } from '../../DeleteCommentaire/ModalDeleteCommentaire';
import { UserIcon } from '../../UserIcon/UserIcon';

import { CommentaireActions } from './CommentaireActions/CommentaireActions';

import './Commentaire.less';

interface CommentaireProps {
  dossierId: string;
  commentaire: CommentaireResponseDto;
  actionsEnabled?: boolean;
  overflowContent?: boolean;
}

export const Commentaire = ({
  dossierId,
  commentaire,
  actionsEnabled = false,
  overflowContent = false,
}: CommentaireProps): React.ReactElement => {
  const [updateFormulaireIsOpen, setUpdateFormulaireIsOpen] =
    React.useState<boolean>(false);
  const deleteCommentaireModal = useModal();

  const formatDate = (date: string): string =>
    moment(date).format(DATE_FORMAT_WITH_TIME);

  if (updateFormulaireIsOpen) {
    return (
      <CommentaireForm
        dossierId={dossierId}
        commentaire={commentaire}
        onClose={() => setUpdateFormulaireIsOpen(false)}
      />
    );
  }

  return (
    <div className="commentaireContainer">
      <UserIcon
        firstName={commentaire.userFirstName || ''}
        lastName={commentaire.userLastName || ''}
        profile={userEventDataDtoProfileEnumToUserDtoProfileEnum(
          commentaire.profile,
        )}
      />
      <div className="commentaireSubContainer">
        <div className="commentaireHeader">
          <span className="commentaireAuthor">
            {getLibelleEntiteRattachement(commentaire)}
          </span>
          <span className="commentaireDate">
            {formatDate(commentaire.dateAjout)}
          </span>
          {commentaire.dateDerniereModification && (
            <span
              className="commentaireModification"
              title={formatDate(commentaire.dateDerniereModification)}
            >
              (modifié)
            </span>
          )}
          {actionsEnabled && (
            <CommentaireActions
              setUpdateFormulaireIsOpen={setUpdateFormulaireIsOpen}
              setDeleteFormulaireIsOpen={deleteCommentaireModal.open}
              commentaire={commentaire}
            />
          )}
        </div>

        <div
          className={`commentaireContent 
          ${commentaire.contenu ? '' : 'empty'} 
          ${overflowContent ? 'overflow' : ''}`}
        >
          {commentaire.contenu || 'Aucun contenu disponible.'}
        </div>
        <ModalDeleteCommentaire
          dossierId={dossierId}
          commentaire={commentaire}
          visible={deleteCommentaireModal.visible}
          onClose={deleteCommentaireModal.close}
        />
      </div>
    </div>
  );
};
